import React, { useMemo } from 'react';

import { SystemTable } from '@sharedCR/common/SystemTable';
import PropTypes from 'prop-types';

import { ExceptionsTestIds } from '../Exceptions.testIds';

import { exceptionsTableConfig } from './ExceptionsTable.config';
import { getExceptionRows } from './ExceptionsTable.utils';

const ExceptionsTable = ({
  exceptions,
  canApprove,
  canEdit,
  onEdit,
  onApprove,
  onDeny,
  onWithdraw,
}) => {
  const rows = useMemo(
    () =>
      getExceptionRows({
        exceptions,
        canEdit,
        canApprove,
        onEdit,
        onApprove,
        onDeny,
        onWithdraw,
      }),
    [exceptions, canEdit, canApprove, onEdit, onApprove, onDeny, onWithdraw],
  );

  return (
    <SystemTable config={exceptionsTableConfig} data={rows} testId={ExceptionsTestIds.TABLE} />
  );
};

ExceptionsTable.propTypes = {
  canApprove: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  exceptions: PropTypes.array.isRequired,
  onApprove: PropTypes.func.isRequired,
  onDeny: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onWithdraw: PropTypes.func.isRequired,
};

export default ExceptionsTable;
